import { ModalConfirmation, useModal } from '@billy/design-system'
import { ReactElement, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { ModalId } from '../../../../enums/modalId'
import { useQuickStartProgress } from '../../hooks/useQuickStartProgress'
import { useTrackQuickStart } from '../../hooks/useTrackQuickStart'

export const SkipQuickStartConfirmationModal = (): ReactElement => {
  const { t } = useTranslation()
  const { skipQuickStart } = useQuickStartProgress()
  const { trackQuickStart } = useTrackQuickStart()
  const { close: closeModal } = useModal(ModalId.SkipQuickStartConfirmationModal)

  const handleConfirm = useCallback(() => {
    skipQuickStart()
    trackQuickStart('Quick Start Dismissed (Client)')
    closeModal()
  }, [closeModal, skipQuickStart, trackQuickStart])

  return (
    <ModalConfirmation
      cancelLabel={t('quick_start.skip_confirmation_modal.return')}
      danger
      id={ModalId.SkipQuickStartConfirmationModal}
      message={t('quick_start.skip_confirmation_modal.message')}
      okButtonTestId="quick-start-skip-confirm"
      okLabel={t('quick_start.skip_confirmation_modal.confirm')}
      onOk={handleConfirm}
      title={t('quick_start.skip_confirmation_modal.title')}
    />
  )
}
